document.addEventListener("DOMContentLoaded", function () {

    const pickupSection = document.getElementById("hubPickupSection");
    const state = document.getElementById("pickupState");
    const city = document.getElementById("pickupCity");
    const hub = document.getElementById("pickupHub");
    const phone = document.getElementById("hubPhone");
    const address = document.getElementById("hubAddress");
    const checkout = document.getElementById("checkout");

    const radios = document.querySelectorAll(
        'input[name="attributes[Delivery Method]"]'
    );

    if (!pickupSection || !state || !city || !hub) return;

    // ------------------------
    // Save Cart Attributes
    // ------------------------

    function saveCartAttributes() {

        const selectedMethod = document.querySelector(
            'input[name="attributes[Delivery Method]"]:checked'
        );

        fetch("/cart/update.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                attributes: {
                    "Delivery Method": selectedMethod ? selectedMethod.value : "",
                    "Pickup State": state.value,
                    "Pickup City": city.value,
                    "Pickup Hub": hub.value,
                    "Hub Phone": phone.value,
                    "Hub Address": address.value
                }
            })
        }).catch(function (err) {
            console.error("Unable to save cart attributes", err);
        });

    }

    // ------------------------
    // Initial State
    // ------------------------

    city.disabled = true;
    hub.disabled = true;
    pickupSection.style.display = "none";

    Object.keys(HUB_DATA)
        .sort()
        .forEach(function (stateName) {
            state.add(new Option(stateName, stateName));
        });

    // ------------------------
    // Delivery Method
    // ------------------------

    radios.forEach(function (radio) {

        radio.addEventListener("change", function () {

            if (this.value === "Nearest Hub Pickup") {

                pickupSection.style.display = "grid";

            } else {

                pickupSection.style.display = "none";

                state.value = "";

                city.innerHTML = '<option value="">Select City</option>';
                hub.innerHTML = '<option value="">Select Pickup Hub</option>';

                city.disabled = true;
                hub.disabled = true;

                phone.value = "";
                address.value = "";

            }

            saveCartAttributes();

        });

    });

    // ------------------------
    // State Changed
    // ------------------------

    state.addEventListener("change", function () {

        city.innerHTML = '<option value="">Select City</option>';
        hub.innerHTML = '<option value="">Select Pickup Hub</option>';

        city.disabled = true;
        hub.disabled = true;

        phone.value = "";
        address.value = "";

        if (!this.value) {
            saveCartAttributes();
            return;
        }

        Object.keys(HUB_DATA[this.value])
            .sort()
            .forEach(function (cityName) {
                city.add(new Option(cityName, cityName));
            });

        city.disabled = false;

        saveCartAttributes();

    });

    // ------------------------
    // City Changed
    // ------------------------

    city.addEventListener("change", function () {

        hub.innerHTML = '<option value="">Select Pickup Hub</option>';

        hub.disabled = true;

        phone.value = "";
        address.value = "";

        if (!this.value) {
            saveCartAttributes();
            return;
        }

        const hubs = HUB_DATA[state.value][this.value];

        hubs.forEach(function (item) {
            hub.add(new Option(item.hub, item.hub));
        });

        hub.disabled = false;

        saveCartAttributes();

    });

    // ------------------------
    // Hub Changed
    // ------------------------

    hub.addEventListener("change", function () {

        phone.value = "";
        address.value = "";

        if (!this.value) {
            saveCartAttributes();
            return;
        }

        const hubs = HUB_DATA[state.value][city.value];

        const selectedHub = hubs.find(function (item) {
            return item.hub === hub.value;
        });

        if (!selectedHub) return;

        phone.value = selectedHub.phone || "";
        address.value = selectedHub.address || "";

        saveCartAttributes();

    });

    // ------------------------
    // Checkout Validation
    // ------------------------

    if (checkout) {

        checkout.addEventListener("click", function (e) {

            const selectedMethod = document.querySelector(
                'input[name="attributes[Delivery Method]"]:checked'
            );

            if (
                selectedMethod &&
                selectedMethod.value === "Nearest Hub Pickup"
            ) {

                if (
                    !state.value ||
                    !city.value ||
                    !hub.value
                ) {

                    e.preventDefault();

                    alert("Please select State, City and Pickup Hub.");

                    return;

                }

            }

            saveCartAttributes();

        });

    }

});